import { render, staticRenderFns } from "./IssueBulkUpdater.vue?vue&type=template&id=21accff6&scoped=true"
import script from "./IssueBulkUpdater.vue?vue&type=script&lang=ts"
export * from "./IssueBulkUpdater.vue?vue&type=script&lang=ts"
import style0 from "./IssueBulkUpdater.vue?vue&type=style&index=0&id=21accff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21accff6",
  null
  
)

export default component.exports